define('app/shared/barchart/horizontalBarChartDirective.js',["https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.12/d3.js"], function (d3) {
	function verticalBarChartDirective() {
		return {
			restrict: 'E',
			replace: false,
			scope: {
				data: '=data'
			},
			templateUrl: 'app/shared/barchart/horizontalBarChart.html',
			link: function(scope, element, attrs) {

				
				element.find(".chart").css('height', attrs.chartHeight);
				element.find(".static-axis").css('height', attrs.staticAxisHeight).css('top', attrs.chartHeight + "px");

				var eleHeight = parseFloat(attrs.chartHeight) + parseFloat(attrs.staticAxisHeight);
				element.find(".clear").css('height', eleHeight + "px");

				var container = element.find(".horizontal-bar-chart");
				var staticAxis = element.find(".static-axis");
				var chart = element.find(".chart");

				var barWidth = 50;
				var margin = {top:0, bottom: 0, left: 150, right: 50};
				var chartHeight = chart.height() - margin.top - margin.bottom,
					staticAxisHeight = staticAxis.height(),
					width = container.width() - margin.left - margin.right;

				var staticAxisSvg = d3.select(staticAxis[0]).append("svg")
					.attr("width", width + margin.left + margin.right)
					.attr("height", staticAxisHeight)
				  .append("g")
				  	.attr("transform", "translate(0," + -staticAxisHeight + ")");

				var chartSvg = d3.select(chart[0]).append("svg")
					.attr("width", width + margin.left + margin.right)
					.attr("height", 0)
				  .append("g")
				  	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

				 chartSvg.append("g")
						.attr("class", "y axis");

				staticAxisSvg.append("g")
						.attr("class", "x axis")
						.attr("transform", "translate(" + margin.left + "," + staticAxisHeight + ")");

				var percents = eval(attrs.percents);
				if (percents) {
					var tickFormat = d3.format(".0%");
				} else {
					var tickFormat = d3.format(",.f");
				}

				scope.$watchCollection('data', function (data) {

					if(data === undefined) {return;}

					var staticAxisSvg = d3.select(staticAxis[0]).select("svg").select("g");
					var chartSvg = d3.select(chart[0]).select("svg")
						.attr("height", data.length * barWidth)
						.select("g");

					var y = d3.scale.ordinal()
						.domain(data.map(function (d){return d.name}))
						.rangeBands([0, data.length * barWidth], .5);
					var yAxis = d3.svg.axis()
						.scale(y)
						.orient("left")
						.outerTickSize(0);

					var x = d3.scale.linear()
						// .domain([d3.min(data, function (d){return d.val}), d3.max(data, function (d){return d.val}) ])
						.domain([0, Math.max(1,d3.max(data, function (d){return d.val})) ])
						.range([0, width]);
					var xAxis = d3.svg.axis()
						.scale(x)
						.orient("bottom")
						.tickFormat(tickFormat)
						.ticks(3)
						.innerTickSize(-chartHeight)
						.outerTickSize(0);

					chartSvg.select(".y.axis")
						//.transition()
						.call(yAxis)
						.selectAll("text")
						.style("text-anchor", "start")
						.attr("x", "-" + margin.left);

					staticAxisSvg.select(".x.axis")
						//.transition()
						.call(xAxis);

					var bars = chartSvg.selectAll(".bar")
						.data(data);

					bars
					  .exit()
						.transition()
						.remove();

					bars
						//.transition()
					  	.attr("y", function (d){return y(d.name)})
					  	.attr("width", function (d){return x(d.val)});

					//Enter bar
					bars
					  .enter().append("rect")
					  	.attr("class", "bar")
					  	.on("click", function (d){app.field(attrs.field).selectMatch(d.name,true)})
					  	.attr("y", function (d){return y(d.name)})
					  	.attr("height", y.rangeBand())
					  	.attr("x", x(0))
					  	.attr("width", x(0))
					  	//.transition()
					  	.attr("width", function (d){return x(d.val)});


					var barText = chartSvg.selectAll(".bartext")
						.data(data);

					barText
					  .exit()
						//.transition()
						.remove();

					barText
						.attr("y", function (d,i){return y(d.name) + y.rangeBand()/2 })
					  	.attr("x", function (d){return x(d.val) + 4})
					  	.text(function (d){if(percents){return Math.round(d.val*1000)/10 + "%"} else{return d.val} })
					  	.attr("opacity", 0)
					  	//.transition()
					  	.attr("opacity", 1);

					barText
					  .enter().append("text")
					  	.attr("class", "bartext")
					  	.attr("text-anchor", "start")
					  	.attr("fill", "#aaa")
					  	.attr("y", function (d,i){return y(d.name) + y.rangeBand()/2 })
					  	.attr("dy", ".4em")
					  	.attr("x", function (d){return x(d.val) + 4})
					  	.text(function (d){if(percents){return Math.round(d.val*1000)/10 + "%"} else{return d.val} })
					  	.attr("opacity", 0)
					  	//.transition()
					  	.attr("opacity", 1);

				});

				$(window).resize(function () {

					width = container.width() - margin.left - margin.right;

					var staticAxisSvg = d3.select(staticAxis[0]).select("svg");
					var chartSvg = d3.select(chart[0]).select("svg");

					staticAxisSvg.attr("width", width + margin.left + margin.right);
					chartSvg.attr("width", width + margin.left + margin.right);

					data = scope.data;
					
					if(data === undefined) {return;}
					
					staticAxisSvg = d3.select(staticAxis[0]).select("svg").select("g");
					chartSvg = chartSvg
						.attr("height", data.length * barWidth)
						.select("g");

					var y = d3.scale.ordinal()
						.domain(data.map(function (d){return d.name}))
						.rangeBands([0, data.length * barWidth], .25);
					var yAxis = d3.svg.axis()
						.scale(y)
						.orient("left")
						.outerTickSize(0);

					var x = d3.scale.linear()
						// .domain([d3.min(data, function (d){return d.val}), d3.max(data, function (d){return d.val}) ])
						.domain([0, d3.max(data, function (d){return d.val}) ])
						.range([0, width]);
					var xAxis = d3.svg.axis()
						.scale(x)
						.orient("bottom")
						.tickFormat(tickFormat)
						.ticks(3)
						.innerTickSize(-chartHeight)
						.outerTickSize(0);

					chartSvg.select(".y.axis")
						//.transition()
						.call(yAxis)
						.selectAll("text")
						.style("text-anchor", "start")
						.attr("x", "-" + margin.left);

					staticAxisSvg.select(".x.axis")
						//.transition()
						.call(xAxis);

					chartSvg.selectAll(".bar")
						.data(data)
						//.transition()
					  	.attr("y", function (d){return y(d.name)})
					  	.attr("width", function (d){return x(d.val)});

					chartSvg.selectAll(".bartext")
						.data(data)
						.attr("y", function (d,i){return y(d.name) + y.rangeBand()/2 })
					  	.attr("x", function (d){return x(d.val) + 4})
					  	.text(function (d){if(percents){return Math.round(d.val*1000)/10 + "%"} else{return d.val} })
					  	.attr("opacity", 0)
					  	//.transition()
					  	.attr("opacity", 1);
				})
			}
		}
	}

  	return verticalBarChartDirective;
});
